import React from 'react';

export default function Services() {
    return <h1 className="services">SERVICES</h1>;
}
